import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import FormGenerator from './shared/forms/FormGenerator';
import withApiData from '../services/withApiData';
import { performApiRequest, getApiDataRequest } from '../redux/apiData';
import { textStyles, themes, colorPalette } from '../styles/styleGuide';
import { hideModalLoader } from '../redux/modal';
import BBCode from './shared/richText/BBCode';
import CloseCross from './shared/icons/CloseCross';
import Spinner from './shared/ui/Spinner';
var connectApiData = withApiData({
  form: 'getForm'
}, function (ownProps) {
  var projectSlug = ownProps.projectSlug,
    formId = ownProps.formId;
  return {
    form: {
      projectSlug: projectSlug,
      formId: formId
    }
  };
});
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var projectSlug = ownProps.projectSlug,
    formId = ownProps.formId;
  projectSlug = String(projectSlug);
  return {
    request: getApiDataRequest(state.apiData, 'postForm', {
      projectSlug: projectSlug,
      formId: formId
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    onSubmit: function onSubmit(values) {
      var projectSlug = ownProps.projectSlug,
        formId = ownProps.formId;
      dispatch(performApiRequest('postForm', {
        projectSlug: projectSlug,
        formId: formId
      }, _objectSpread({}, values)));
    },
    completeLoading: function completeLoading() {
      dispatch(hideModalLoader());
    }
  };
};
var Form = /*#__PURE__*/function (_Component) {
  function Form() {
    var _this;
    _classCallCheck(this, Form);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Form, [].concat(args));
    _defineProperty(_this, "state", {
      loading: false,
      title: ''
    });
    return _this;
  }
  _inherits(Form, _Component);
  return _createClass(Form, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.form.data) {
        this.props.completeLoading();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        form = _this$props.form,
        completeLoading = _this$props.completeLoading;
      var oldForm = prevProps.form;
      if (!oldForm.data && form.data) {
        completeLoading();
      }
      if (form.data && form.data.title && this.state.title !== form.data.title) {
        this.setState({
          title: form.data.title
        });
      }
    }
  }, {
    key: "getPopulatedFormFieldValues",
    value: function getPopulatedFormFieldValues(formFields) {
      var formFieldsOptions = formFields.flatMap(function (formField) {
        return formField.options;
      });
      var populatedFormFieldsValues = {};
      formFieldsOptions.forEach(function (formFieldsOption) {
        if (formFieldsOption.populate) {
          populatedFormFieldsValues = _objectSpread(_objectSpread({}, populatedFormFieldsValues), {}, _defineProperty({}, formFieldsOption.name, formFieldsOption.populate));
        }
      });
      return populatedFormFieldsValues;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        form = _this$props2.form,
        request = _this$props2.request,
        onSubmit = _this$props2.onSubmit,
        error = _this$props2.error;
      var _this$state = this.state,
        title = _this$state.title,
        loading = _this$state.loading;
      var El;
      if (form.data && !form.data.thanks) {
        var _form$data;
        El = __jsx(Fragment, null, __jsx(FormTitle, {
          "data-id": "components_Form_FormTitle"
        }, title), form.data.intro && __jsx(FormIntro, {
          "data-id": "components_Form_FormIntro"
        }, __jsx(BBCode, {
          content: form.data.intro,
          "data-id": "components_Form_BBCode"
        })), error && __jsx(FormErrors, {
          "data-id": "components_Form_FormErrors"
        }, error), __jsx(FormGenerator, {
          fields: form.data.fields,
          formNote: form.data.footer,
          defaultValues: this.getPopulatedFormFieldValues((_form$data = form.data) === null || _form$data === void 0 ? void 0 : _form$data.fields),
          submitLabel: form.data.buttonLabel,
          submitFn: onSubmit,
          loading: loading,
          "data-id": "components_Form_FormGenerator"
        }));
      }
      if (form.data && request && request.networkStatus === 'success' && form.data.thanks) {
        El = __jsx("div", {
          "data-e2e-form-message": "success",
          "data-id": "components_Form_div"
        }, __jsx(FormTitle, {
          "data-id": "components_Form_FormTitle"
        }, title), __jsx(BBCode, {
          content: form.data.thanks,
          "data-id": "components_Form_BBCode"
        }));
      }
      if (request && request.networkStatus === 'loading') {
        El = __jsx(FormStatusMessage, {
          "data-e2e-form-message": "loading",
          "data-id": "components_Form_FormStatusMessage"
        }, __jsx(Spinner, {
          size: "small",
          "data-id": "components_Form_Spinner"
        }), __jsx("p", {
          "data-id": "components_Form_p"
        }, "Een moment geduld..."));
      }
      if (request && request.networkStatus === 'failed') {
        El = __jsx(FormStatusMessage, {
          "data-e2e-form-message": "failed",
          "data-id": "components_Form_FormStatusMessage"
        }, __jsx(CloseCross, {
          color: "#eeeeee",
          "data-id": "components_Form_CloseCross"
        }), __jsx("p", {
          "data-id": "components_Form_p"
        }, "Er is iets mis gegaan. Probeer de pagina te verversen."));
      }
      return __jsx("div", {
        "data-id": "components_Form_div"
      }, El);
    }
  }]);
}(Component);
export default connectApiData(connect(mapStateToProps, mapDispatchToProps)(Form));
var FormTitle = styled.h2(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  margin: 0 0 15rem 0;\n"])), textStyles.sectionTitle, colorPalette.headerGrey);
var FormIntro = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", "\n  color: ", ";\n  margin-bottom: 25rem;\n"])), textStyles.introText, themes.algemeen.primary);
var FormErrors = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background: #eee;\n  padding: 20rem;\n  margin-bottom: 25rem;\n  ", " color: red;\n  border: solid 1px ", ";\n  border-radius: 5rem;\n"])), textStyles.introText, colorPalette.lightBeige);
var FormStatusMessage = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  min-height: 300rem;\n  align-items: center;\n  flex-direction: column;\n\n  svg {\n    margin-bottom: 30rem;\n    width: 120rem !important;\n    height: 120rem !important;\n  }\n"])));